import { Box } from '@/common/components';
import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

export const infoCardStyles: CSS = {
  display: 'flex',
  flexDirection: 'column',
};

export const separation: CSS = {
  marginTop: '$6',
};

export const StyledContactButtonsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
});

export const StyledReasonsContainer = styled(Box, {
  marginLeft: '$10',
});
